function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { Card, Box, GridAlpha } from '@applyboard/crystal-ui';
import { useScholarshipPageContext } from "../../contexts";
import { formatDate, formatScholarshipAmountRange } from "../utils";
import { AmountItem } from "./items/AmountItem";
import { LastUpdatedItem } from "./items/LastUpdatedItem";
import { AutoApplyItem } from "./items/AutoApplyItem";
import { SourceItem } from "./items/SourceItem";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var ScholarshipInfoBox = function ScholarshipInfoBox() {
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  var showSourceItem = !!scholarship.sourceUrl;
  var amountRange = useMemo(function () {
    return formatScholarshipAmountRange({
      amountFrom: scholarship.awardAmountFrom,
      amountTo: scholarship.awardAmountTo,
      currencySymbol: scholarship.awardAmountCurrencySymbol,
      currencyCode: scholarship.awardAmountCurrencyCode,
      amountType: scholarship.awardAmountType
    });
  }, [scholarship.awardAmountFrom, scholarship.awardAmountTo, scholarship.awardAmountCurrencySymbol, scholarship.awardAmountCurrencyCode, scholarship.awardAmountType]);
  var infoBoxItems = useMemo(function () {
    return _objectSpread({
      amount: _jsx(AmountItem, {
        amountRange: amountRange
      }),
      autoApply: _jsx(AutoApplyItem, {
        autoApply: scholarship.automaticallyApplied
      }),
      lastUpdated: _jsx(LastUpdatedItem, {
        lastUpdated: formatDate(scholarship.updatedAt)
      })
    }, showSourceItem && {
      source: _jsx(SourceItem, {
        sourceUrl: scholarship.sourceUrl
      })
    });
  }, [amountRange, scholarship.automaticallyApplied, scholarship.updatedAt, scholarship.sourceUrl, showSourceItem]);
  return _jsx(Box, {
    children: _jsx(Card, {
      emphasis: "elevated",
      children: _jsx(GridAlpha, {
        columns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: "repeat(".concat(showSourceItem ? 4 : 3, ", 1fr)")
        },
        rowGap: 6,
        rows: {
          xs: 'auto',
          sm: 'auto'
        },
        children: Object.entries(infoBoxItems).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            item = _ref2[1];
          return _jsx(GridAlpha.Item, {
            children: item
          }, key);
        })
      })
    })
  });
};